import React from 'react';
import Modal from 'react-modal';
import { NavLink } from 'react-router-dom';

class PaidPlanModal extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <Modal
        className="hc-modal-content hc-modal-payup"
        overlayClassName="hc-modal-overlay"
        isOpen={this.props.isOpen}
        onRequestClose={this.props.close}
        appElement={document.querySelector('.page-container')}
        contentLabel=""
      >
        <div className="hc-payup-header">
          <span>Premium feature</span>
          <span className="hc-payup-close" onClick={this.props.close}>
            <i className="fa fa-times" />
          </span>
        </div>

        <div className="hc-premium-text">
          <p>
            This option isn&apos;t available on this plan. To use this feature, please choose a higher subscription plan
          </p>
        </div>

        <div className="hc-premium-text">
          <NavLink
            className="bulk-action-btn secondary-btn"
            onClick={this.props.close}
            to={this.props.paths.profileSubscription}
          >
            Choose a plan
          </NavLink>
        </div>
      </Modal>
    );
  }
}

export default PaidPlanModal;
